import { Link } from "react-router-dom";

function Arrow({ external }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
      {external ? (
        <path
          d="M4.5 11.5L11.5 4.5M7 4.5h4.5V9"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
        />
      ) : (
        <path
          d="M3 8h10M9 4l4 4-4 4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
        />
      )}
    </svg>
  );
}

export default function TextLink({ href, children, external = false, className = "" }) {
  const classes = `text-link ${className}`.trim();
  const content = (
    <>
      <span className="text-link-label">{children}</span>
      <Arrow external={external} />
      {external ? <span className="sr-only"> (opens in a new tab)</span> : null}
    </>
  );

  if (external || href.startsWith("http") || href.startsWith("mailto:")) {
    const isHttp = external || href.startsWith("http");
    return (
      <a
        className={classes}
        href={href}
        {...(isHttp ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        {content}
      </a>
    );
  }

  return (
    <Link className={classes} to={href}>
      {content}
    </Link>
  );
}
